import React from "react";
import SwisscardLogoSmall from "../../../../../resources/images/scd-header-logo-xs.svg";

import "./styles.scss";
import { Box } from "@mui/material";

export default function Logo(): React.JSX.Element {
  return (
    <Box className="scd-footer-logo">
      <img src={SwisscardLogoSmall} alt={"Swisscard"} />
    </Box>
  );
}
